const STORAGE_PREFIX = "adatis.dashboardInsightsUnitId";

const storageKey = (tenantId: number): string => `${STORAGE_PREFIX}.${tenantId}`;

export const getDashboardInsightsUnitId = (tenantId: number): number | null => {
  if (typeof window === "undefined" || tenantId <= 0) {
    return null;
  }

  try {
    const raw = localStorage.getItem(storageKey(tenantId));
    if (!raw) {
      return null;
    }

    const parsed = Number(raw);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  } catch {
    return null;
  }
};

export const setDashboardInsightsUnitId = (
  tenantId: number,
  unitId: number | null
): void => {
  if (typeof window === "undefined" || tenantId <= 0) {
    return;
  }

  try {
    if (unitId === null || unitId <= 0) {
      localStorage.removeItem(storageKey(tenantId));
      return;
    }

    localStorage.setItem(storageKey(tenantId), String(unitId));
  } catch {
    // localStorage unavailable
  }
};
